module.exports = "/images/demo_tally.png?197d0c0b82062ebecbc31cd60f39095b";